import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { FormField } from '@/shared/ui/FormField';
import { fetchServiceCategories, type ServiceCategory } from './api';

type CategoryProps = {
  category: ServiceCategory;
  selected: ReadonlySet<number>;
  onToggle: (serviceId: number) => void;
};

const CategoryNode = ({ category, selected, onToggle }: CategoryProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const checkedCount = category.children.filter((child) => selected.has(child.id)).length;

  return (
    <div>
      <div className="tree-box-content">
        <span className="pull-left pointer" onClick={() => setIsOpen((prev) => !prev)}>
          <small className="label pull-right bg-blue">{isOpen ? '-' : '+'}</small>
        </span>
        <span className="tree-name">
          {category.name} ({checkedCount})
        </span>
      </div>
      {isOpen &&
        category.children.map((child) => (
          <div
            key={child.id}
            className="tree-box-content"
            style={{ paddingLeft: '1em', borderLeft: 'solid rgb(235, 235, 235)' }}
          >
            <label className="checkbox-inline">
              <input type="checkbox" checked={selected.has(child.id)} onChange={() => onToggle(child.id)} />
              {child.name}
            </label>
          </div>
        ))}
    </div>
  );
};

type Props = {
  selectedIds: number[];
  errors?: string[];
  onChange: (ids: number[]) => void;
};

/** Collapsible tree of service categories with checkable works. */
export const ServiceTreeField = ({ selectedIds, errors, onChange }: Props) => {
  const categories = useQuery({ queryKey: ['ai-service-categories'], queryFn: fetchServiceCategories });
  const selected = new Set(selectedIds);

  const toggle = (serviceId: number) =>
    onChange(selected.has(serviceId) ? selectedIds.filter((id) => id !== serviceId) : [...selectedIds, serviceId]);

  return (
    <FormField label="Услуги" errors={errors}>
      {categories.isLoading && <p>Загрузка...</p>}
      {categories.error && <p className="text-red">Не удалось загрузить услуги</p>}
      {categories.data?.map((category) => (
        <CategoryNode key={category.id} category={category} selected={selected} onToggle={toggle} />
      ))}
    </FormField>
  );
};
